import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

const CommunityGuidelines = () => {
  document.title = "Community & Acceptable Use Policy | Porcher";

  return (
    <div className="page-content">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <Card className="border-0 shadow-sm mt-4">
              <CardBody className="p-4">
                <h1 className="mb-3">Community &amp; Acceptable Use Policy</h1>
                <p className="text-muted small mb-4">Last updated: August 22, 2026</p>

                <div className="content">
                  <h5 className="mt-4">1. Purpose</h5>
                  <p>
                    This policy sets expectations for how everyone — Homeowners, Tenants, Applicants, and anyone else
                    with access to the platform operated by Patronage Reservoir LLC, a Nevada limited liability
                    company doing business as Porcher ("Porcher", "we", "our", or "us") — communicates, shares content,
                    and behaves while using it. It is incorporated by reference into our{" "}
                    <Link to="/terms-of-service">Terms of Service</Link>.
                  </p>

                  <h5 className="mt-4">2. Who This Applies To</h5>
                  <p>
                    This policy applies to every interactive feature on the Platform, including property group chat,
                    inspection conversations, support ticket messages, listings, rental applications, and any file or
                    photo you upload.
                  </p>

                  <h5 className="mt-4">3. Respectful Communication</h5>
                  <p>
                    Keep messages on the Platform relevant, honest, and respectful. Property, inspection, and ticket
                    conversations exist to coordinate real rental business — leasing, maintenance, payments, and
                    support — not for unrelated or abusive communication.
                  </p>

                  <h5 className="mt-4">4. Prohibited Conduct</h5>
                  <p>You agree not to, on or through the Platform:</p>
                  <ul>
                    <li>Harass, bully, threaten, or intimidate another user</li>
                    <li>Post or send hateful, discriminatory, or harassing content, including anything that would violate our{" "}
                      <Link to="/fair-housing-policy">Fair Housing &amp; Anti-Discrimination Policy</Link>
                    </li>
                    <li>Send sexually explicit, violent, or otherwise obscene content</li>
                    <li>Impersonate another person or misrepresent your affiliation with a property or account</li>
                    <li>Send spam, unsolicited advertising, or run automated scraping against the Platform</li>
                    <li>Share another user's personal information without their consent</li>
                  </ul>

                  <h5 className="mt-4">5. Uploads &amp; Content Standards</h5>
                  <p>
                    Photos and documents you upload (property photos, inspection media, income or lease documents,
                    ticket attachments) must relate to the property, application, or ticket they're attached to. Do
                    not upload content that is illegal, infringes someone else's rights, is obscene, or contains
                    malicious code.
                  </p>

                  <h5 className="mt-4">6. Accuracy &amp; Honesty</h5>
                  <p>
                    Listings, rental applications, inspection reports, and support tickets must be truthful and
                    accurate. Do not submit false information, impersonate an applicant, or misrepresent a property's
                    condition.
                  </p>

                  <h5 className="mt-4">7. Reporting Violations</h5>
                  <p>
                    If you see content or behavior that violates this policy, please report it through the support
                    portal so we can review it.
                  </p>

                  <h5 className="mt-4">8. Enforcement</h5>
                  <p>
                    We may remove content, issue a warning, or suspend or terminate an account that violates this
                    policy. Where required by law, we may also report illegal content or activity to law enforcement.
                  </p>

                  <h5 className="mt-4">9. Limited Monitoring</h5>
                  <p>
                    Porcher does not pre-screen every message or upload before it's sent, but we may review reported
                    or flagged content to enforce this policy, consistent with our{" "}
                    <Link to="/privacy-policy">Privacy Policy</Link>.
                  </p>

                  <h5 className="mt-4">10. Changes to This Policy</h5>
                  <p>
                    We may update this policy from time to time. Continued use of the Platform after an update means
                    you accept the revised policy.
                  </p>

                  <h5 className="mt-4">11. Contact Us</h5>
                  <p>
                    If you have questions about this Community &amp; Acceptable Use Policy, please contact us through
                    the support portal.
                  </p>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CommunityGuidelines;
